import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarDisplayComponent } from './avatar-display.component';

@NgModule({
  declarations: [AvatarDisplayComponent],
  imports: [CommonModule],
  exports: [AvatarDisplayComponent]
})
export class AvatarDisplayModule {}
